import { render, staticRenderFns } from "./StudentListItem.vue?vue&type=template&id=7c2f2b0c&scoped=true&"
import script from "./StudentListItem.vue?vue&type=script&lang=js&"
export * from "./StudentListItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentListItem.vue?vue&type=style&index=0&id=7c2f2b0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2f2b0c",
  null
  
)

component.options.__file = "StudentListItem.vue"
export default component.exports